@if (!item.hidden && isVisibleByNppPermission) {
  <!-- item.url -->
  @if (item.url && !item.externalUrl && !item.function) {
    <a
      class="nav-link"
      [ngClass]="item.classes"
      [queryParams]="item.queryParams || null"
      [routerLink]="[item.url]"
      [routerLinkActive]="['active']"
      [routerLinkActiveOptions]="{
        paths: item.exactMatch ? 'exact' : 'subset',
        queryParams: 'ignored',
        matrixParams: 'ignored',
        fragment: 'ignored'
      }"
      [target]="item.openInNewTab ? '_blank' : '_self'"
    >
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>
  }
  <!-- item.externalUrl -->
  @if (item.url && item.externalUrl && !item.function) {
    <a class="nav-link" [ngClass]="item.classes" [href]="item.url" [target]="item.openInNewTab ? '_blank' : '_self'">
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>
  }
  <!-- item.function -->
  @if (!item.url && item.function) {
    <span class="nav-link" [ngClass]="item.classes" (click)="item.function()">
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </span>
  }
  <!-- item.url && item.function -->
  @if (item.url && !item.externalUrl && item.function) {
    <a
      class="nav-link"
      [ngClass]="item.classes"
      (click)="item.function()"
      [routerLink]="[item.url]"
      [routerLinkActive]="['active']"
      [routerLinkActiveOptions]="{
        paths: item.exactMatch ? 'exact' : 'subset',
        queryParams: 'ignored',
        matrixParams: 'ignored',
        fragment: 'ignored'
      }"
      [target]="item.openInNewTab ? '_blank' : '_self'"
    >
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>
  }
  <!-- item.externalUrl && item.function -->
  @if (item.url && item.externalUrl && item.function) {
    <a
      class="nav-link"
      [ngClass]="item.classes"
      (click)="item.function()"
      [href]="item.url"
      [target]="item.openInNewTab ? '_blank' : '_self'"
    >
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>
  }
  <ng-template #itemContent>
    @if (item.icon) {
      <mat-icon class="nav-link-icon">{{ item.icon }}</mat-icon>
    }
    @if (item.faicon) {
      <i class="fas font-awe-navi {{ item.faicon }}"></i>
    }
    @if (item.img) {
      <img [src]="item.img" class="img-thumbnail-conf" />
    }
    <span class="nav-link-title">{{ item.title }}</span>
    @if (item.badge) {
      <span class="nav-link-badge" [ngStyle]="{ 'background-color': item.badge.bg, color: item.badge.fg }">
        {{ item.badge.title }}
      </span>
    }
  </ng-template>
}
